import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=5c90cef0"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&id=5c90cef0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c90cef0')) {
      api.createRecord('5c90cef0', component.options)
    } else {
      api.reload('5c90cef0', component.options)
    }
    module.hot.accept("./BaseToggle.vue?vue&type=template&id=5c90cef0", function () {
      api.rerender('5c90cef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseToggle.vue"
export default component.exports